/**
 * Centralized public links for the client.
 *
 * Prefer overriding via env when deploying so we don't need a code change
 * to rotate/replace links.
 */
export const DISCORD_INVITE_URL =
  process.env.NEXT_PUBLIC_DISCORD_INVITE_URL ?? 'https://discord.gg/PtGq7PSPv9';
